// extracted by mini-css-extract-plugin
module.exports = {"botton":"PriceBx_botton__3gjbT","title":"PriceBx_title__1qWBx","subTitle":"PriceBx_subTitle__13gNe","amount":"PriceBx_amount__2fNlG","eachCase":"PriceBx_eachCase__21vsf"};